// Envia mensagem de scroll para a janela pai quando o hook é chamado.
const useMessageScroll = () => {
    return () => {
        window.parent.postMessage({ type: 'scroll-mensagem' }, '*');
    }
};

export default useMessageScroll;